<div class="inner-container">
  <ng-content></ng-content>
</div>
